import { sanitizeJsonLdStrings } from "~/utils/jsonld-sanitize";

export const getBlogBreadcrumbSchemaScript = ({
  baseUrl,
  hid = "blogs-breadcrumb-schema",
  currentPage,
} = {}) => {
  const normalizedBaseUrl = (baseUrl || "").replace(/\/$/, "");

  const itemListElement = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: normalizedBaseUrl,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Inspiration",
      item: `${normalizedBaseUrl}/blogs/inspiration`,
    },
  ];

  if (currentPage?.name && currentPage?.item) {
    itemListElement.push({
      "@type": "ListItem",
      position: 3,
      name: currentPage.name,
      item: currentPage.item,
    });
  }

  return [
    {
      hid,
      type: "application/ld+json",
      innerHTML: JSON.stringify(
        sanitizeJsonLdStrings({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement,
        })
      ),
    },
  ];
};
